const PENDING_PLAN_ID_KEY = "pendingPlanId";
const PENDING_PLAN_NAME_KEY = "pendingPlanName";
const PENDING_PLAN_DATA_KEY = "pendingPlanData";
const PENDING_PAYMENT_REFERENCE_KEY = "pendingPaymentReference";
const PENDING_MARKET_ID_KEY = "pendingMarketId";
const PENDING_SELLER_REQUEST_KEY = "pendingSellerRequest";

export const getPendingPlanSelection = () => {
  const rawPlanData = sessionStorage.getItem(PENDING_PLAN_DATA_KEY);

  return {
    planId: sessionStorage.getItem(PENDING_PLAN_ID_KEY),
    planName: sessionStorage.getItem(PENDING_PLAN_NAME_KEY),
    paymentReference: sessionStorage.getItem(PENDING_PAYMENT_REFERENCE_KEY),
    marketId: sessionStorage.getItem(PENDING_MARKET_ID_KEY),
    planData: rawPlanData ? JSON.parse(rawPlanData) : null,
  };
};

export const persistPendingPlanSelection = ({
  planId,
  planName,
  planData,
  paymentReference,
  marketId,
}: {
  planId?: string;
  planName?: string;
  planData?: Record<string, any> | null;
  paymentReference?: string;
  marketId?: string;
}) => {
  if (planId) {
    sessionStorage.setItem(PENDING_PLAN_ID_KEY, planId);
  }

  if (planName) {
    sessionStorage.setItem(PENDING_PLAN_NAME_KEY, planName);
  }

  if (planData) {
    sessionStorage.setItem(PENDING_PLAN_DATA_KEY, JSON.stringify(planData));
  }

  if (paymentReference) {
    sessionStorage.setItem(PENDING_PAYMENT_REFERENCE_KEY, paymentReference);
  }

  if (marketId) {
    sessionStorage.setItem(PENDING_MARKET_ID_KEY, marketId);
  }
};

export const clearPendingPlanSelection = () => {
  sessionStorage.removeItem(PENDING_PLAN_ID_KEY);
  sessionStorage.removeItem(PENDING_PLAN_NAME_KEY);
  sessionStorage.removeItem(PENDING_PLAN_DATA_KEY);
  sessionStorage.removeItem(PENDING_PAYMENT_REFERENCE_KEY);
  sessionStorage.removeItem(PENDING_MARKET_ID_KEY);
};

export const getPendingSellerRequest = () => {
  const rawValue = localStorage.getItem(PENDING_SELLER_REQUEST_KEY);
  return rawValue ? JSON.parse(rawValue) : null;
};

export const persistPendingSellerRequest = (payload: Record<string, any>) => {
  localStorage.setItem(PENDING_SELLER_REQUEST_KEY, JSON.stringify(payload));
};

export const clearPendingSellerRequest = () => {
  localStorage.removeItem(PENDING_SELLER_REQUEST_KEY);
};